import { useEffect } from 'react';
import type { Link } from 'src/apis/api-utilities';
import type { UpgradeableDealIdsResponse } from 'src/apis/transport-auction/types';
import { useAxios } from 'src/hooks/use-axios';

type ExecuteOptions = {
  link: Link;
};

export function useUpgradeableDealIds(link?: Link | null) {
  const request = useAxios(
    (axios, baseConfig, { link }: ExecuteOptions) =>
      axios.request<UpgradeableDealIdsResponse>({
        ...baseConfig,
        url: link.href,
      }),
    { neededOnPageLoad: false }
  );

  useEffect(() => {
    if (!link) return;
    request.execute({ link });
    // oxlint-disable-next-line exhaustive-deps
  }, [link]);

  if (!link) return;

  return request;
}

export type UpgradeableDealIdsRequest = ReturnType<
  typeof useUpgradeableDealIds
>;
